export default [
  {
    path: '/mapping',
    name: 'Mapping',
    component: () => import('@/views/mapping/index.vue'),
    meta: {
      auth: true,
      title: 'LON映射',
      keepAlive: true,
      headerTheme: 'dark',
    }
  },
  {
    path: '/release',
    name: 'Release',
    component: () => import('@/views/release/index.vue'),
    meta: {
      auth: true,
      title: '释放',
      keepAlive: true,
      headerTheme: 'dark',
    }
  }
]

